import ErrorTooltip from 'Components/ErrorTooltip';
import ReportDetailsHeader from 'Components/ReportDetailsHeader';
import ToolTip from 'Components/ToolTip';
import { TooltipMsg } from 'Components/ToolTipMessage';
import { Field, FieldProps, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Input, Label, Row } from 'reactstrap';
import env from "environment_system/env_system";
import { Get } from 'VesselMaster/vesselMaster.hooks';
import { useSelector } from 'react-redux';
import { RootState } from 'index';
import { queryKeyes } from 'shared/queryKeys';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';
interface DraftsAndDisplacementProps {
    alertBool: boolean;
    refreshKey: any;
    setRefreshKey: any;
    cargoChangePopupBool: boolean;
    editValues?: any,
    setEditValues?: any,
    editReportBool?: boolean
    containerChangePopupBool?: boolean
}

const DraftsAndDisplacement = ({
    alertBool,
    refreshKey,
    setRefreshKey,
    cargoChangePopupBool,
    editValues,
    setEditValues,
    editReportBool,
    containerChangePopupBool
}: DraftsAndDisplacementProps) => {
    const { discardwarning } = useEditReport();
    const { values, errors, touched, handleChange, handleBlur, setValues, setFieldValue }:
        { values: any, errors: any, touched: any, handleChange: any, handleBlur: any, setValues: any, setFieldValue: any } = useFormikContext<any>();
    const { ReportID, VesselID } = useSelector((state: RootState) => state.Reporting);
    const [fetchingPrevData, setFetchingPrevData] = useState<boolean>(false)
    const [errorPreviousData, setErrorPreviousData] = useState<boolean>(false)

    /**
     * fetch previous data of draft_and_displacement and ballast_details and assign to initial values
     */
    const fetchPreviousData = async () => {
        setFetchingPrevData(true)
        /** function to fech data */
        const data = await Get(queryKeyes.vessel.DraftsAndDisplacementPrevData.url(VesselID, ReportID), VesselID, ReportID);
        if (data && Object.keys(data)?.length > 0) {
            delete data?.draft_displacement?.id; // delete id
            delete data?.draft_displacement?.report_index; // delete vessel
            /** create draft_and_displacement object for formik */
            const draftsAndDisplacementData = {
                ...data?.draft_displacement,
                ...(values?.draft_and_displacement?.id && { id: values?.draft_and_displacement?.id }),
                vessel: values?.draft_and_displacement?.vessel,
                voyage_information: values?.draft_and_displacement?.voyage_information,
                vessel_reporting_information: values?.draft_and_displacement?.vessel_reporting_information,
            }
            delete data?.ballast_detail?.id; // delete id
            delete data?.ballast_detail?.report_index;
            /** create ballast_detail object for formik */
            const ballastDetailData = {
                ...data?.ballast_detail,
                ...(values?.ballast_details?.id && { id: values?.ballast_details?.id }),
                vessel: values?.ballast_details?.vessel,
                voyage_information: values?.ballast_details?.voyage_information,
                vessel_reporting_information: values?.ballast_details?.vessel_reporting_information,
            }
            /** update formik object */
            setValues({
                ...values,
                draft_and_displacement: draftsAndDisplacementData,
                ballast_details: ballastDetailData
            })
            /** update trim value explicitly */
            setFieldValue('draft_and_displacement.trim',
                ((data?.draft_displacement?.draft_aft ?? 0) - (data?.draft_displacement?.fwd_draft ?? 0)).toFixed(2)
            )
            setRefreshKey(refreshKey + 1)
            setFetchingPrevData(false)
        } else {
            setFetchingPrevData(false);
            setErrorPreviousData(true);
        }
    };

    useEffect(() => {
        if (editValues && editValues?.deck_officer?.draft_and_displacement?.id > 0) {
            setEditValues({
                ...editValues,
                deck_officer: {
                    ...editValues?.deck_officer,
                    draft_and_displacement: values?.draft_and_displacement
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.draft_and_displacement])

    return (
        <Card className="p-0 mb-0 rounded-0 border-top-0 border-start-0 border-end-0">
            <CardHeader className="py-2 px-0">
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">
                                Drafts & Displacement
                            </h4>
                            <p className="card-title-desc pos-start">
                                All readings since last report
                            </p>
                        </Col>
                        <Col>
                            <ReportDetailsHeader />
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            <CardBody className="px-0 py-0 mt-2" key={refreshKey}>
                <Row>
                    <div className="d-flex flex-wrap">
                        <Col lg={2} className="ps-0 py-1">
                            <Label className="asteric mb-0" for="fwd_draft">
                                Fwd draft
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="fwd_draft_msg"
                                ></i>
                            </Label>
                            <ToolTip
                                target="fwd_draft_msg"
                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                    (item: any) => item.target === "fwd_draft_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="mb-1 input-group">
                                <Field name="draft_and_displacement.fwd_draft">
                                    {({ field, form }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            type="text"
                                            className="form-control text-right border-end-0"
                                            id="fwd_draft"
                                            name={field.name}
                                            autoFocus={true}
                                            onChange={(e: any) => {
                                                handleChange(e);
                                                form.setFieldValue(
                                                    "draft_and_displacement.trim",
                                                    Number.isNaN((parseFloat(values?.draft_and_displacement.draft_aft) - parseFloat(e.target.value))) ? 0.00 :
                                                        (parseFloat(values?.draft_and_displacement.draft_aft) - parseFloat(e.target.value)).toFixed(2)
                                                );
                                            }}
                                            onBlur={(e: any) => {
                                                handleBlur(e);
                                                handleChange(e);
                                                form.setFieldValue(
                                                    "draft_and_displacement.trim",
                                                    Number.isNaN((parseFloat(values?.draft_and_displacement.draft_aft) - parseFloat(e.target.value))) ? 0.00 :
                                                        (parseFloat(values?.draft_and_displacement.draft_aft) - parseFloat(e.target.value)).toFixed(2)
                                                );
                                            }}
                                            defaultValue={
                                                values &&
                                                values?.draft_and_displacement?.fwd_draft
                                            }
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text round_border">
                                    m
                                </div>
                            </div>
                            {errors?.draft_and_displacement &&
                                errors?.draft_and_displacement?.fwd_draft &&
                                touched?.draft_and_displacement?.fwd_draft &&
                                !alertBool && !cargoChangePopupBool && !containerChangePopupBool &&
                                env?.form_validation === true && !discardwarning &&
                                <ErrorTooltip
                                    target="fwd_draft"
                                    message={
                                        errors?.draft_and_displacement?.fwd_draft
                                    }
                                    open={
                                        errors?.draft_and_displacement &&
                                            errors?.draft_and_displacement?.fwd_draft
                                            ? true
                                            : false
                                    }
                                />
                            }
                        </Col>
                        <Col lg={2} className="p-1 ps-2">
                            <Label className="asteric mb-0" for="draft_mid">
                                Mid draft
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="draft_mid_msg"
                                ></i>
                            </Label>
                            <ToolTip
                                target="draft_mid_msg"
                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                    (item: any) => item.target === "draft_mid_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="mb-3 input-group">
                                <Field name="draft_mid">
                                    {() => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            type="text"
                                            className="form-control text-right"
                                            id="draft_mid"
                                            name="draft_and_displacement.draft_mid"
                                            onBlur={handleBlur}
                                            onChange={(e: any) => handleChange(e)}
                                            defaultValue={
                                                values?.draft_and_displacement?.draft_mid
                                            }
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text round_border">
                                    m
                                </div>{" "}
                            </div>
                            {errors?.draft_and_displacement &&
                                touched?.draft_and_displacement?.draft_mid &&
                                errors?.draft_and_displacement?.draft_mid &&
                                !alertBool && !cargoChangePopupBool && !containerChangePopupBool &&
                                env?.form_validation === true && !discardwarning && (
                                    <ErrorTooltip
                                        target="draft_mid"
                                        message={
                                            errors?.draft_and_displacement?.draft_mid
                                        }
                                        open={
                                            errors?.draft_and_displacement &&
                                                errors?.draft_and_displacement?.draft_mid
                                                ? true
                                                : false
                                        }
                                    />
                                )}
                        </Col>
                        <Col lg={2} className="p-1">
                            <Label className="asteric mb-0" for="draft_aft">
                                Aft draft
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="draft_aft_msg"
                                ></i>
                            </Label>
                            <ToolTip
                                target="draft_aft_msg"
                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                    (item: any) => item.target === "draft_aft_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="mb-3 input-group">
                                <Field name="draft_and_displacement.draft_aft">
                                    {({ field, form }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            type="text"
                                            className="form-control text-right"
                                            id="draft_aft"
                                            name={field.name}
                                            onChange={(e: any) => {
                                                handleChange(e);
                                                form.setFieldValue(
                                                    "draft_and_displacement.trim",
                                                    Number.isNaN((parseFloat(e.target.value) - parseFloat(values?.draft_and_displacement.fwd_draft))) ? 0.00 :
                                                        ((parseFloat(e.target.value) - parseFloat(values?.draft_and_displacement.fwd_draft)).toFixed(2))
                                                );
                                            }}
                                            onBlur={(e: any) => {
                                                handleBlur(e);
                                                handleChange(e);
                                                form.setFieldValue(
                                                    "draft_and_displacement.trim",
                                                    Number.isNaN((parseFloat(e.target.value) - parseFloat(values?.draft_and_displacement.fwd_draft))) ? 0.00 :
                                                        ((parseFloat(e.target.value) - parseFloat(values?.draft_and_displacement.fwd_draft)).toFixed(2))
                                                );
                                            }}
                                            defaultValue={
                                                values &&
                                                values?.draft_and_displacement.draft_aft
                                            }
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text round_border">
                                    m
                                </div>
                            </div>
                            {errors?.draft_and_displacement &&
                                touched?.draft_and_displacement?.draft_aft &&
                                errors?.draft_and_displacement?.draft_aft &&
                                !alertBool && !cargoChangePopupBool && !containerChangePopupBool &&
                                env?.form_validation === true && !discardwarning && (
                                    <ErrorTooltip
                                        target="draft_aft"
                                        message={
                                            errors?.draft_and_displacement?.draft_aft
                                        }
                                        open={
                                            errors?.draft_and_displacement &&
                                                errors?.draft_and_displacement?.draft_aft
                                                ? true
                                                : false
                                        }
                                    />
                                )}
                        </Col>
                        <Col lg={2} className="p-1">
                            <Label className="asteric mb-0" for="displacement">
                                Displacement
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="displacement_msg"
                                ></i>
                            </Label>
                            <ToolTip
                                target="displacement_msg"
                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                    (item: any) =>
                                        item.target === "displacement_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="mb-3 input-group">
                                <Field name="draft_and_displacement.displacement">
                                    {({ field }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            type="text"
                                            className="form-control text-right border-end-0"
                                            id="displacement"
                                            name={field.name}
                                            onBlur={handleBlur}
                                            onChange={(e: any) => handleChange(e)}
                                            defaultValue={
                                                values &&
                                                values?.draft_and_displacement?.displacement
                                            }
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text round_border">
                                    mt
                                </div>
                            </div>
                            {errors?.draft_and_displacement &&
                                touched?.draft_and_displacement?.displacement &&
                                errors?.draft_and_displacement?.displacement &&
                                !alertBool && !cargoChangePopupBool && !containerChangePopupBool &&
                                env?.form_validation === true && !discardwarning && (
                                    <ErrorTooltip
                                        target="displacement"
                                        message={
                                            errors?.draft_and_displacement?.displacement
                                        }
                                        open={
                                            errors?.draft_and_displacement &&
                                                errors?.draft_and_displacement?.displacement
                                                ? true
                                                : false
                                        }
                                    />
                                )}
                        </Col>
                        <Col lg={2} className="p-1">
                            <Label className="mb-0" for="trim">
                                Trim
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="trim_msg"
                                />
                            </Label>
                            <ToolTip
                                target="trim_msg"
                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                    (item: any) => item.target === "trim_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="mb-3 input-group">
                                <Field
                                    type="text"
                                    className="form-control text-right cursor-not-allowed"
                                    id="trim"
                                    name="draft_and_displacement.trim"
                                    disabled
                                />
                                <div className="input-group-text round_border">
                                    m
                                </div>
                                {errors?.draft_and_displacement &&
                                    errors?.draft_and_displacement?.trim &&
                                    !alertBool && !cargoChangePopupBool && !containerChangePopupBool &&
                                    env?.form_validation === true && !discardwarning && (
                                        <ErrorTooltip
                                            target="trim"
                                            message={errors?.draft_and_displacement?.trim}
                                            open={
                                                errors?.draft_and_displacement &&
                                                    errors?.draft_and_displacement?.trim
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </div>
                        </Col>
                        <Col lg={2} className='text-end'>
                            {!editReportBool &&
                                <p
                                    className={`link_color_blue pointer ${errorPreviousData && 'font-smaller label-red'}`}
                                    onClick={() => !errorPreviousData && fetchPreviousData()}
                                    key={refreshKey}
                                >
                                    {
                                        fetchingPrevData ? 'Fetching Data....' :
                                            errorPreviousData ? 'No previous data available!' :
                                                'Fetch Previous Data'
                                    }
                                </p>
                            }
                        </Col>
                    </div>
                </Row>
            </CardBody>
        </Card>
    )
}

export default DraftsAndDisplacement